(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.HanezzaColorVariantGallery = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
  var MEDIA_PREFIX = 'gid://shopify/MediaImage/';

  function normalizeColor(value) {
    return String(value == null ? '' : value).trim().toLocaleLowerCase('tr-TR');
  }

  function normalizeMediaId(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!raw) return null;
    if (raw.indexOf('gid://shopify/') === 0) {
      if (raw.indexOf(MEDIA_PREFIX) !== 0) return null;
      var suffix = raw.slice(MEDIA_PREFIX.length);
      return /^\d+$/.test(suffix) ? suffix : null;
    }
    return /^\d+$/.test(raw) ? raw : null;
  }

  function canonicalImageUrl(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!raw) return '';
    return raw.replace(/^https?:/i, '').split('#')[0].split('?')[0];
  }

  function buildMediaUrlIndex(media) {
    var index = Object.create(null);
    (Array.isArray(media) ? media : []).forEach(function(item) {
      var id = normalizeMediaId(item && item.id);
      if (!id) return;
      [item.mobileUrl, item.desktopUrl, item.url].forEach(function(url) {
        var key = canonicalImageUrl(url);
        if (key && !index[key]) index[key] = id;
      });
    });
    return index;
  }

  function resolveMediaIdForUrl(url, index) {
    return (index && index[canonicalImageUrl(url)]) || null;
  }

  function resolveMediaIdForImageSources(image, index) {
    if (!image) return null;
    var sources = [
      image.currentSrc,
      image.src,
      image.getAttribute && image.getAttribute('src')
    ];
    for (var i = 0; i < sources.length; i += 1) {
      var mediaId = resolveMediaIdForUrl(sources[i], index);
      if (mediaId) return mediaId;
    }
    return null;
  }

  function parseGalleryContract(value) {
    if (!value) return null;
    try {
      var parsed = typeof value === 'string' ? JSON.parse(value) : value;
      if (!parsed || parsed.version !== 1 || !Array.isArray(parsed.groups) || !Array.isArray(parsed.generalMediaIds)) return null;
      return parsed;
    } catch (_) {
      return null;
    }
  }

  function normalizeIds(ids) {
    return (Array.isArray(ids) ? ids : []).map(normalizeMediaId).filter(Boolean);
  }

  function resolveGallerySelection(contract, selectedColor) {
    if (!contract || contract.version !== 1) return { mode: 'all', mediaIds: [], primaryMediaId: null };
    var colorKey = normalizeColor(selectedColor);
    var group = (contract.groups || []).find(function(item) {
      return item && normalizeColor(item.color) === colorKey;
    });
    if (group) {
      return { mode: 'group', mediaIds: normalizeIds(group.mediaIds), primaryMediaId: normalizeMediaId(group.primaryMediaId) };
    }
    var general = normalizeIds(contract.generalMediaIds);
    if (general.length > 0) return { mode: 'general', mediaIds: general, primaryMediaId: general[0] };
    return { mode: 'all', mediaIds: [], primaryMediaId: null };
  }

  function resolveGalleryPlan(selection, renderedMediaIds, originalOrder) {
    var renderedSet = new Set((renderedMediaIds || []).map(String));
    var original = (originalOrder || []).map(String).filter(function(id) { return renderedSet.has(id); });
    if (!selection || selection.mode === 'all') return { visibleIds: original, primaryMediaId: original[0] || null };
    var visible = (selection.mediaIds || []).map(String).filter(function(id, index, arr) {
      return renderedSet.has(id) && arr.indexOf(id) === index;
    });
    if (visible.length === 0) return { visibleIds: original, primaryMediaId: original[0] || null };
    var primary = selection.primaryMediaId && visible.indexOf(String(selection.primaryMediaId)) !== -1
      ? String(selection.primaryMediaId)
      : visible[0];
    return { visibleIds: visible, primaryMediaId: primary };
  }

  function shouldRestoreAll(selection, renderedMediaIds) {
    if (!selection || selection.mode === 'all') return true;
    var rendered = new Set((renderedMediaIds || []).map(String));
    return !(selection.mediaIds || []).some(function(id) { return rendered.has(String(id)); });
  }

  function getNodeMediaId(node, urlIndex) {
    var explicit = normalizeMediaId(node && node.getAttribute && node.getAttribute('data-sekronet-media-id'));
    if (explicit) return explicit;
    var mappedUrl = node && node.getAttribute && node.getAttribute('data-sekronet-media-url');
    var mappedId = resolveMediaIdForUrl(mappedUrl, urlIndex);
    if (mappedId) return mappedId;
    var image = node && node.tagName === 'IMG' ? node : node && node.querySelector ? node.querySelector('img') : null;
    return resolveMediaIdForImageSources(image, urlIndex);
  }

  function restoreCollection(parent, nodes) {
    if (!parent) return;
    nodes.forEach(function(node) {
      node.hidden = false;
      node.style.removeProperty('display');
      parent.appendChild(node);
    });
  }

  function applyCollectionPlan(parent, nodes, visibleIds, urlIndex) {
    if (!parent) return;
    var visibleSet = new Set(visibleIds);
    var byId = new Map();
    nodes.forEach(function(node) {
      var id = getNodeMediaId(node, urlIndex);
      if (id) {
        node.setAttribute('data-sekronet-media-id', id);
        byId.set(id, node);
      }
    });
    visibleIds.forEach(function(id) {
      var node = byId.get(id);
      if (!node) return;
      node.hidden = false;
      node.style.removeProperty('display');
      parent.appendChild(node);
    });
    nodes.forEach(function(node) {
      var id = getNodeMediaId(node, urlIndex);
      if (id && visibleSet.has(id)) return;
      node.hidden = true;
      node.style.display = 'none';
      parent.appendChild(node);
    });
  }

  function bootstrap(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : null);
    if (!doc) return null;
    var dataNode = doc.getElementById('hanezza-color-variant-gallery-data');
    if (!dataNode) return null;
    var payload;
    try { payload = JSON.parse(dataNode.textContent || '{}'); } catch (_) { return null; }
    var contract = parseGalleryContract(payload.contract);
    var urlIndex = buildMediaUrlIndex(payload.media);

    var mobileParent = doc.getElementById('mobile-image-slider');
    var desktopParent = doc.getElementById('desktop-gallery-scroll');
    var thumbParent = doc.getElementById('mobile-gallery-thumbs');
    var modalDialog = doc.getElementById('hanezza-product-gallery-dialog');
    var modalBody = doc.getElementById('hanezza-product-gallery-dialog-body');
    var modalParent = doc.getElementById('hanezza-product-gallery-dialog-list');
    var modalStatus = doc.getElementById('hanezza-product-gallery-dialog-status');
    var modalOpenButton = doc.getElementById('hanezza-gallery-all-button');
    var modalCloseButton = modalDialog && modalDialog.querySelector ? modalDialog.querySelector('[data-hanezza-gallery-close]') : null;
    var mobileNodes = mobileParent ? Array.from(mobileParent.children).filter(function(node) { return node.querySelector && node.querySelector('img'); }) : [];
    var desktopNodes = desktopParent ? Array.from(desktopParent.querySelectorAll('img')) : [];
    var thumbNodes = thumbParent ? Array.from(thumbParent.children).filter(function(node) { return node.querySelector && node.querySelector('img'); }) : [];
    var modalNodes = modalParent ? Array.from(modalParent.children).filter(function(node) { return node.querySelector && node.querySelector('img'); }) : [];
    var dots = Array.from(doc.querySelectorAll('.prada-dot'));

    var mobileOriginal = mobileNodes.slice();
    var desktopOriginal = desktopNodes.slice();
    var thumbOriginal = thumbNodes.slice();
    var modalOriginal = modalNodes.slice();
    var mobileOriginalIds = mobileOriginal.map(function(node) { return getNodeMediaId(node, urlIndex); }).filter(Boolean);
    var desktopOriginalIds = desktopOriginal.map(function(node) { return getNodeMediaId(node, urlIndex); }).filter(Boolean);
    var modalOriginalIds = modalOriginal.map(function(node) { return getNodeMediaId(node, urlIndex); }).filter(Boolean);
    var renderedIds = Array.from(new Set(mobileOriginalIds.concat(desktopOriginalIds).concat(modalOriginalIds)));
    var originalOrder = mobileOriginalIds.length ? mobileOriginalIds : (desktopOriginalIds.length ? desktopOriginalIds : modalOriginalIds);
    var currentColor = '';
    var currentVisibleIds = originalOrder.slice();
    var previousBodyOverflow = '';

    function syncThumbState(mediaId, visibleIds) {
      var visibleSet = new Set((visibleIds || []).map(String));
      thumbOriginal.forEach(function(node) {
        var id = getNodeMediaId(node, urlIndex);
        var active = Boolean(mediaId && id === String(mediaId) && visibleSet.has(id));
        if (node.classList && typeof node.classList.toggle === 'function') node.classList.toggle('is-active', active);
        if (node.setAttribute) node.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function visibleModalNodes() {
      return modalOriginal.filter(function(node) {
        return node && !node.hidden && (!node.style || node.style.display !== 'none');
      });
    }

    function updateModalStatus(index) {
      var visible = visibleModalNodes();
      var safeIndex = visible.length ? Math.max(0, Math.min(Number(index) || 0, visible.length - 1)) : 0;
      if (modalStatus) {
        var countText = visible.length ? String(safeIndex + 1) + '/' + visible.length : '0/0';
        modalStatus.textContent = currentColor ? currentColor + ' · ' + countText : countText;
      }
    }

    var modalZoomState = {
      item: null,
      image: null,
      scale: 1,
      x: 0,
      y: 0,
      startScale: 1,
      startDistance: 0,
      startMidX: 0,
      startMidY: 0,
      startX: 0,
      startY: 0,
      panStartClientX: 0,
      panStartClientY: 0,
      panStartX: 0,
      panStartY: 0,
      touchStartX: 0,
      touchStartY: 0,
      moved: false,
      pinching: false,
      lastTapTime: 0,
      lastTapX: 0,
      lastTapY: 0,
      lastTapImage: null
    };

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function touchDistance(touches) {
      if (!touches || touches.length < 2) return 0;
      var dx = touches[1].clientX - touches[0].clientX;
      var dy = touches[1].clientY - touches[0].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function touchMidpoint(touches) {
      return {
        x: (touches[0].clientX + touches[1].clientX) / 2,
        y: (touches[0].clientY + touches[1].clientY) / 2
      };
    }

    function clampModalPan(item, scale, x, y) {
      if (!item || scale <= 1) return { x: 0, y: 0 };
      var maxX = Math.max(0, (item.clientWidth * (scale - 1)) / 2);
      var maxY = Math.max(0, (item.clientHeight * (scale - 1)) / 2);
      return {
        x: clamp(x, -maxX, maxX),
        y: clamp(y, -maxY, maxY)
      };
    }

    function applyModalZoom() {
      var state = modalZoomState;
      if (!state.item || !state.image) return;
      if (state.scale <= 1.01) {
        state.scale = 1;
        state.x = 0;
        state.y = 0;
      } else {
        var bounded = clampModalPan(state.item, state.scale, state.x, state.y);
        state.x = bounded.x;
        state.y = bounded.y;
      }
      state.item.classList.toggle('is-zoomed', state.scale > 1.01);
      state.item.classList.toggle('is-pinching', Boolean(state.pinching));
      state.image.style.transform = 'translate3d(' + state.x + 'px,' + state.y + 'px,0) scale(' + state.scale + ')';
      state.image.setAttribute('data-hanezza-zoom-scale', state.scale.toFixed(2));
    }

    function resetModalZoom() {
      var state = modalZoomState;
      if (state.item) state.item.classList.remove('is-zoomed', 'is-pinching');
      if (state.image) {
        state.image.style.removeProperty('transform');
        state.image.removeAttribute('data-hanezza-zoom-scale');
      }
      state.item = null;
      state.image = null;
      state.scale = 1;
      state.x = 0;
      state.y = 0;
      state.startScale = 1;
      state.startDistance = 0;
      state.moved = false;
      state.pinching = false;
    }

    function activateModalZoomImage(image) {
      if (!image) return null;
      if (modalZoomState.image && modalZoomState.image !== image) resetModalZoom();
      modalZoomState.image = image;
      modalZoomState.item = image.closest ? image.closest('.hanezza-product-gallery-dialog-item') : null;
      return modalZoomState.item;
    }

    function setModalZoom(image, scale, x, y) {
      var item = activateModalZoomImage(image);
      if (!item) return;
      modalZoomState.scale = clamp(Number(scale) || 1, 1, 4);
      modalZoomState.x = Number(x) || 0;
      modalZoomState.y = Number(y) || 0;
      applyModalZoom();
    }

    function isModalZoomed() {
      return modalZoomState.scale > 1.01;
    }

    function toggleModalDoubleTapZoom(image, clientX, clientY) {
      var item = activateModalZoomImage(image);
      if (!item) return;
      if (isModalZoomed()) {
        setModalZoom(image, 1, 0, 0);
        return;
      }
      var rect = item.getBoundingClientRect();
      var relativeX = clientX - (rect.left + rect.width / 2);
      var relativeY = clientY - (rect.top + rect.height / 2);
      var targetScale = 2;
      setModalZoom(image, targetScale, -relativeX * (targetScale - 1), -relativeY * (targetScale - 1));
    }

    function bindModalZoom() {
      modalOriginal.forEach(function(item) {
        var image = item && item.querySelector ? item.querySelector('img') : null;
        if (!image) return;

        image.addEventListener('touchstart', function(event) {
          var touches = event.touches;
          activateModalZoomImage(image);
          modalZoomState.moved = false;

          if (touches && touches.length >= 2) {
            var midpoint = touchMidpoint(touches);
            modalZoomState.pinching = true;
            modalZoomState.startScale = modalZoomState.scale;
            modalZoomState.startDistance = touchDistance(touches) || 1;
            modalZoomState.startMidX = midpoint.x;
            modalZoomState.startMidY = midpoint.y;
            modalZoomState.startX = modalZoomState.x;
            modalZoomState.startY = modalZoomState.y;
            applyModalZoom();
            return;
          }

          if (touches && touches.length === 1) {
            modalZoomState.touchStartX = touches[0].clientX;
            modalZoomState.touchStartY = touches[0].clientY;
            if (isModalZoomed()) {
              modalZoomState.panStartClientX = touches[0].clientX;
              modalZoomState.panStartClientY = touches[0].clientY;
              modalZoomState.panStartX = modalZoomState.x;
              modalZoomState.panStartY = modalZoomState.y;
            }
          }
        }, { passive: true });

        image.addEventListener('touchmove', function(event) {
          if (modalZoomState.image !== image) return;
          var touches = event.touches;

          if (touches && touches.length >= 2) {
            event.preventDefault();
            var distance = touchDistance(touches);
            var midpoint = touchMidpoint(touches);
            var nextScale = modalZoomState.startScale * (distance / Math.max(modalZoomState.startDistance, 1));
            modalZoomState.pinching = true;
            modalZoomState.moved = true;
            setModalZoom(
              image,
              nextScale,
              modalZoomState.startX + (midpoint.x - modalZoomState.startMidX),
              modalZoomState.startY + (midpoint.y - modalZoomState.startMidY)
            );
            return;
          }

          if (touches && touches.length === 1 && isModalZoomed()) {
            event.preventDefault();
            var dx = touches[0].clientX - modalZoomState.panStartClientX;
            var dy = touches[0].clientY - modalZoomState.panStartClientY;
            if (Math.abs(dx) > 3 || Math.abs(dy) > 3) modalZoomState.moved = true;
            setModalZoom(image, modalZoomState.scale, modalZoomState.panStartX + dx, modalZoomState.panStartY + dy);
            return;
          }

          if (touches && touches.length === 1) {
            var moveX = touches[0].clientX - modalZoomState.touchStartX;
            var moveY = touches[0].clientY - modalZoomState.touchStartY;
            if (Math.abs(moveX) > 8 || Math.abs(moveY) > 8) modalZoomState.moved = true;
          }
        }, { passive: false });

        image.addEventListener('touchend', function(event) {
          if (modalZoomState.image !== image) return;

          if (modalZoomState.pinching) {
            if (!event.touches || event.touches.length < 2) {
              modalZoomState.pinching = false;
              modalZoomState.moved = true;
              applyModalZoom();
            }
            return;
          }

          if (event.touches && event.touches.length) return;
          var touch = event.changedTouches && event.changedTouches[0];
          if (!touch || modalZoomState.moved) {
            modalZoomState.moved = false;
            return;
          }

          var now = Date.now();
          var sinceLastTap = now - modalZoomState.lastTapTime;
          var tapDx = touch.clientX - modalZoomState.lastTapX;
          var tapDy = touch.clientY - modalZoomState.lastTapY;
          var nearLastTap = Math.sqrt(tapDx * tapDx + tapDy * tapDy) < 30;

          if (modalZoomState.lastTapImage === image && sinceLastTap > 0 && sinceLastTap < 320 && nearLastTap) {
            if (event.cancelable) event.preventDefault();
            toggleModalDoubleTapZoom(image, touch.clientX, touch.clientY);
            modalZoomState.lastTapTime = 0;
            modalZoomState.lastTapImage = null;
          } else {
            modalZoomState.lastTapTime = now;
            modalZoomState.lastTapX = touch.clientX;
            modalZoomState.lastTapY = touch.clientY;
            modalZoomState.lastTapImage = image;
          }
        }, { passive: false });

        image.addEventListener('touchcancel', function() {
          modalZoomState.pinching = false;
          modalZoomState.moved = false;
          applyModalZoom();
        }, { passive: true });

        image.addEventListener('dblclick', function(event) {
          event.preventDefault();
          toggleModalDoubleTapZoom(image, event.clientX, event.clientY);
        });
      });
    }

    function getColorValues() {
      var values = [];
      Array.from(doc.querySelectorAll('.color-option[data-option-value]')).forEach(function(button) {
        var value = String(button.getAttribute('data-option-value') || '').trim();
        if (value && !values.some(function(item) { return normalizeColor(item) === normalizeColor(value); })) values.push(value);
      });
      return values;
    }

    function findColorButton(value) {
      var normalized = normalizeColor(value);
      var matches = Array.from(doc.querySelectorAll('.color-option[data-option-value]')).filter(function(button) {
        return normalizeColor(button.getAttribute('data-option-value')) === normalized;
      });
      return matches.find(function(button) {
        return button.closest && button.closest('.custom-mobile-view');
      }) || matches[0] || null;
    }

    function switchModalColor(direction) {
      if (isModalZoomed()) return false;
      resetModalZoom();
      var values = getColorValues();
      if (values.length < 2) return false;
      var currentIndex = values.findIndex(function(value) { return normalizeColor(value) === normalizeColor(currentColor); });
      if (currentIndex < 0) currentIndex = 0;
      var nextIndex = (currentIndex + direction + values.length) % values.length;
      var nextColor = values[nextIndex];
      var button = findColorButton(nextColor);
      if (!button || typeof button.click !== 'function') return false;
      currentColor = nextColor;
      button.click();
      var schedule = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : function(callback) { setTimeout(callback, 0); };
      schedule(function() {
        if (modalBody) modalBody.scrollTo({ top: 0, behavior: 'smooth' });
        updateModalStatus(0);
      });
      return true;
    }

    function apply(color) {
      currentColor = String(color == null ? '' : color).trim();
      var selection = resolveGallerySelection(contract, color);
      var restoreAll = shouldRestoreAll(selection, renderedIds);
      var plan = resolveGalleryPlan(selection, renderedIds, originalOrder);
      if (restoreAll) {
        restoreCollection(mobileParent, mobileOriginal);
        restoreCollection(desktopParent, desktopOriginal);
        restoreCollection(thumbParent, thumbOriginal);
        restoreCollection(modalParent, modalOriginal);
      } else {
        applyCollectionPlan(mobileParent, mobileOriginal, plan.visibleIds, urlIndex);
        applyCollectionPlan(desktopParent, desktopOriginal, plan.visibleIds, urlIndex);
        applyCollectionPlan(thumbParent, thumbOriginal, plan.visibleIds, urlIndex);
        applyCollectionPlan(modalParent, modalOriginal, plan.visibleIds, urlIndex);
      }

      var dotIds = restoreAll ? originalOrder.slice(0, 4) : plan.visibleIds;
      dots.forEach(function(dot, index) {
        var mediaId = index < Math.min(4, dotIds.length) ? dotIds[index] : null;
        dot.style.display = mediaId ? '' : 'none';
        dot.setAttribute('data-index', String(index));
        if (mediaId) dot.setAttribute('data-sekronet-media-id', mediaId);
        else dot.removeAttribute('data-sekronet-media-id');
        dot.classList.toggle('active', index === 0 && Boolean(mediaId));
      });

      var visibleIds = restoreAll ? originalOrder : plan.visibleIds;
      currentVisibleIds = visibleIds.slice();
      var activeMediaId = plan.primaryMediaId || visibleIds[0] || null;
      syncThumbState(activeMediaId, visibleIds);
      updateModalStatus(0);

      if (mobileParent && plan.primaryMediaId) {
        var primary = mobileParent.querySelector('[data-sekronet-media-id="' + plan.primaryMediaId + '"]');
        if (primary && typeof mobileParent.scrollTo === 'function') {
          mobileParent.scrollTo({ left: primary.offsetLeft || 0, behavior: 'smooth' });
        }
      }
      return plan;
    }

    var initial = doc.querySelector('.color-option.selected');
    apply(initial ? initial.getAttribute('data-option-value') : '');
    bindModalZoom();

    function openModal() {
      if (!modalDialog || typeof modalDialog.showModal !== 'function') return false;
      if (modalDialog.open) return true;
      resetModalZoom();
      previousBodyOverflow = doc.body ? doc.body.style.overflow : '';
      if (doc.body) doc.body.style.overflow = 'hidden';
      modalDialog.showModal();
      if (modalBody) modalBody.scrollTop = 0;
      updateModalStatus(0);
      if (modalCloseButton && typeof modalCloseButton.focus === 'function') modalCloseButton.focus();
      return true;
    }

    if (modalOpenButton) {
      modalOpenButton.addEventListener('click', function() { openModal(); });
    }

    var heroTapStart = null;
    if (mobileParent) {
      mobileParent.addEventListener('pointerdown', function(event) {
        var image = event.target && event.target.closest ? event.target.closest('img') : null;
        if (!image) {
          heroTapStart = null;
          return;
        }
        heroTapStart = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          time: Date.now()
        };
      }, { passive: true });

      mobileParent.addEventListener('pointerup', function(event) {
        if (!heroTapStart || heroTapStart.id !== event.pointerId) return;
        var dx = event.clientX - heroTapStart.x;
        var dy = event.clientY - heroTapStart.y;
        var elapsed = Date.now() - heroTapStart.time;
        heroTapStart = null;
        if (Math.abs(dx) > 12 || Math.abs(dy) > 12 || elapsed > 700) return;
        openModal();
      }, { passive: true });

      mobileParent.addEventListener('pointercancel', function() { heroTapStart = null; }, { passive: true });
    }

    if (modalCloseButton && modalDialog) {
      modalCloseButton.addEventListener('click', function() { modalDialog.close(); });
    }

    if (modalDialog) {
      modalDialog.addEventListener('close', function() {
        resetModalZoom();
        if (doc.body) doc.body.style.overflow = previousBodyOverflow;
        if (modalOpenButton && typeof modalOpenButton.focus === 'function') modalOpenButton.focus();
      });
    }

    if (modalBody) {
      var modalScrollTicking = false;
      modalBody.addEventListener('scroll', function() {
        if (modalScrollTicking) return;
        modalScrollTicking = true;
        var scheduleScroll = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : function(callback) { setTimeout(callback, 0); };
        scheduleScroll(function() {
          var visible = visibleModalNodes();
          if (visible.length) {
            var bodyRect = modalBody.getBoundingClientRect();
            var nearest = visible.reduce(function(best, node) {
              return Math.abs(node.getBoundingClientRect().top - bodyRect.top) < Math.abs(best.getBoundingClientRect().top - bodyRect.top) ? node : best;
            }, visible[0]);
            updateModalStatus(Math.max(0, visible.indexOf(nearest)));
          }
          modalScrollTicking = false;
        });
      }, { passive: true });

      var hanezzaGallerySwipe = null;
      modalBody.addEventListener('pointerdown', function(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (isModalZoomed()) {
          hanezzaGallerySwipe = null;
          return;
        }
        hanezzaGallerySwipe = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, { passive: true });
      modalBody.addEventListener('pointerup', function(event) {
        if (isModalZoomed()) {
          hanezzaGallerySwipe = null;
          return;
        }
        if (!hanezzaGallerySwipe || hanezzaGallerySwipe.id !== event.pointerId) return;
        var dx = event.clientX - hanezzaGallerySwipe.x;
        var dy = event.clientY - hanezzaGallerySwipe.y;
        hanezzaGallerySwipe = null;
        if (Math.abs(dx) < 56 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
        switchModalColor(dx > 0 ? 1 : -1);
      }, { passive: true });
      modalBody.addEventListener('pointercancel', function() { hanezzaGallerySwipe = null; }, { passive: true });
    }

    doc.addEventListener('click', function(event) {
      var target = event.target && event.target.closest ? event.target.closest('.color-option') : null;
      if (!target) return;
      var color = target.getAttribute('data-option-value') || '';
      var schedule = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : function(callback) { setTimeout(callback, 0); };
      schedule(function() { apply(color); });
    });

    return {
      apply: apply,
      contract: contract,
      mediaIndex: urlIndex,
      openModal: openModal,
      switchModalColor: switchModalColor,
      resetModalZoom: resetModalZoom,
      isModalZoomed: isModalZoomed
    };
  }

  return {
    normalizeColor: normalizeColor,
    normalizeMediaId: normalizeMediaId,
    canonicalImageUrl: canonicalImageUrl,
    buildMediaUrlIndex: buildMediaUrlIndex,
    resolveMediaIdForUrl: resolveMediaIdForUrl,
    resolveMediaIdForImageSources: resolveMediaIdForImageSources,
    parseGalleryContract: parseGalleryContract,
    resolveGallerySelection: resolveGallerySelection,
    resolveGalleryPlan: resolveGalleryPlan,
    shouldRestoreAll: shouldRestoreAll,
    bootstrap: bootstrap
  };
});
